import CardVM from 'view_models/common/course/card/card-vm';
import InstructorCarousel from 'view_models/common/instructor-carousel'

export default function (data) {
  var self = this;

  self.showSSORegister = ko.observable(Kadenze.isKadenze);
  self.showSSOLogin = ko.observable(false);
  self.showSignup = ko.observable(false);
  self.showLogin = ko.observable(false);
  self.$el = $('#temp_program_container');
  self.recaptcha_site_key = $('#recaptcha-site-key-json').val();

  self.just_registered = false;
  self.current_modal = null;

  self.program = ko.observable();

  self.newuser = ko.observable({
    first_name: ko.observable(),
    last_name: ko.observable(),
    email: ko.observable(),
    password: ko.observable(),
    password_confirmation: ko.observable(),
    agreed_to_terms_and_privacy: ko.observable(),
    recaptcha_token: ko.observable()
  });

  self.justEnrolled = ko.observable(false);

  self.open_date = ko.computed(function() {
    if (self.program()) {
      if (self.program().open()) {
        if (self.program().upcoming()) {
          var str = 'Open for Enrollment';

          if (self.program().apx_release_date && self.program().apx_release_date())
            str += '. Starts ' + self.program().apx_release_date();

          return str;
        } else {
          return 'Open Now';
        }
      } else {
        return 'In Development';
      }
    }
  });

  self.enrollment_fields_info = ko.observable({});

  self.loginuser = ko.observable({
    email: ko.observable(),
    password: ko.observable()
  });

  this.bindData = data => {
    this.program(
      ko.mapping.fromJS(
        data,
        {
          'courses': {
            create: ({ data }) => new CardVM(data, this),
          }
        }
      )
    );

    this.program().enrollment_fields().forEach(field => {
      if (this.program().current_user && this.program().current_user.for_credit_info)
        this.enrollment_fields_info()[field.user_attribute()] = this.program()
          .current_user
          .for_credit_info[field.user_attribute()] || null;

      this.enrollment_fields_info()[field.user_attribute()] = null;
    });

    const action = Kadenze.Util.getParameterByName('action');
    const cookie = $.cookie('register.oauth');

    if (action && action == 'register') {
      this.enrollOrRegister();
    } else if (cookie) {
      this.enrollOrRegister();

      $.removeCookie('register.oauth');

      Kadenze.WebApp.fbEventTrack('CompleteRegistration', {
        content_name: this.program().title()
      });

      ga('send', {
        hitType: 'event',
        eventCategory: 'account',
        eventAction: 'CompleteRegistration',
        eventLabel: this.program().title()
      });
    }

    setTimeout(this.initInstructorsCarousel, 500);
  };

  self.trackEnrollment = function() {
    console.log('tracking enrollment');

    Kadenze.WebApp.fbEventTrack('Lead', {
      content_name: self.program().title(),
      content_category: 'Program'
    });

    ga('send', { hitType: 'event', eventCategory: 'program',
      eventAction: 'Lead', eventLabel: self.program().title()
    });

    Kadenze.Analytics.track(
      'student_ui',
      'enrollment_started',
      {
        source_medium: 'program_show',
        new_role: 'program'
      }
    );

    return true;
  };

  self.initializeVideo = function() {
    var $vidWrapper = $('#vid-player');
    var promo_vid = self.program().program_promo_video;

    if (promo_vid) {
      var vid = promo_vid;

      var mediaUrls = {
        h264_360_url: vid.h264_360_url ? vid.h264_360_url() : '',
        h264_720_url: vid.h264_720_url ? vid.h264_720_url() : ''
      };

      var mediaSubtitles = ko.toJS(vid.subtitles);

      var opts = {
        poster: self.program().cinema_logo()
      };

      vid.renderer = new Kadenze.VideoPlayer(
        $vidWrapper,
        mediaUrls,
        'vjs-student-skin',
        mediaSubtitles,
        null,
        opts
      );

      _.each(mediaSubtitles,function(sub){vid.renderer.addTextTrack(sub);});
    }
  };

  self.userPresent = function() {
    return Boolean(self.program().current_user || self.just_registered);
  };

  self.showModal = function(modalSelector) {
    if (self.current_modal)
      self.current_modal.modal('hide');

    self.current_modal = $(modalSelector);
    self.current_modal.modal('show');
  };

  self.hasEnrollmentFields = function() {
    return self.program() && self.program().enrollment_fields().length > 0;
  };

  self.enrollment_fields_group = ko.computed(function() {
    if (!self.program())
      return {};

    return _.groupBy(self.program().enrollment_fields(), function(field) {
      return field.section();
    });
  });

  self.forCreditInfo = function(attrObs) {
    return ko.computed({
      read: function() {
        return self.enrollment_fields_info()[attrObs()] || null;
      },

      write: function(val) {
        self.enrollment_fields_info()[attrObs()] = val;
        self.enrollment_fields_info.valueHasMutated();
      }
    });
  };

  self.enrollOrRegister = function() {
    if (self.userPresent()) {
      if (self.hasEnrollmentFields()) {
        self.showModal('#js-course-enroll-modal--fields');
      } else {
        self.enroll();
      }
    } else {
      self.showRegisterOptions();
    }
  };

  self.showRegisterOptions = function() {
    self.showModal('#js-course-enroll-modal--authenticate');
  };


  self.register = function(vm, evt) {
    var loader = Ladda.create(evt.target);
    loader.start();

    if (self.recaptcha_site_key && Kadenze.isKadenze) {
      grecaptcha.enterprise.ready(function() {
        grecaptcha.enterprise.execute(self.recaptcha_site_key, { action: 'external_imports' }).then(function(token) {
          self.newuser().recaptcha_token(token); // Set the token in the newuser object
          submitRegistrationRequest();
        });
      });
    } else {
      submitRegistrationRequest();
    }

    function submitRegistrationRequest() {
      // Retrieve the user registration data from the observable object
      var userRegistrationData = ko.mapping.toJS(self.newuser);

      var req = new Kadenze.AjaxRequest({
        type: 'POST',
        url: Kadenze.Routes.user_registration_path(),
        data: { user: userRegistrationData }
      });

      req.done(function(res) {
        self.just_registered = true;
        self.enrollOrRegister(vm, evt);

        if (Kadenze.ENVIRONMENT === 'prod' && Kadenze.isKadenze) {
          Kadenze.WebApp.onFbLoaded(() => {
            fbq('init', '483925218455659', {
              em: res.resource.email.toLowerCase(),
              fn: res.resource.first_name.toLowerCase(),
              ln: res.resource.last_name.toLowerCase()
            });

            Kadenze.WebApp.fbEventTrack('CompleteRegistration', {
              content_name: self.program().title(),
            });
          });

          ga('send', {
            hitType: 'event',
            eventCategory: 'account',
            eventAction: 'CompleteRegistration',
            eventLabel: self.program().title()
          });
        }
      });

      req.fail(function(xhr, status, msg) {
        if (xhr.responseJSON)
          msg = xhr.responseJSON.errors;

        new Kadenze.Notice.error({ message: msg });
      });

      req.always(function() {
        loader.stop();
      });
    }
  };


  self.login = function(vm, evt) {
    var loader = Ladda.create(evt.target);

    loader.start();

    var req = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.user_session_path(),
      data: { user: ko.mapping.toJS(self.loginuser) }
    });

    req.done(function(res) {
      self.just_registered = true;

      if (res.csrf)
        $('meta[name=\'csrf-token\']').prop('content', res.csrf);

      if (res.program_ids && _.contains(res.program_ids, self.program().id())) {
        // already enrolled
        window.location = Kadenze.Routes.root_path;
      } else {
        self.enroll(vm, evt);
      }
    });

    req.fail(function(xhr, status, msg) {
      if (xhr.responseJSON)
        msg = xhr.responseJSON.error;

      new Kadenze.Notice.error({message: msg});

      loader.stop();
    });
  };

  self.enroll = function(vm, evt) {
    if (evt) {
      var loader = Ladda.create(evt.target);
      loader.start();
    }

    self.trackEnrollment();

    var req = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.program_enroll_path(self.program().id())
    });

    req.done(function(res) {
      new Kadenze.Notice.success({ message: res.message });

      if (res && res.redirect_path)
        window.location.pathname = res.redirect_path;
    });

    req.fail(function(xhr, status, msg) {
      if (xhr.responseJSON)
        msg = xhr.responseJSON.errors;

      new Kadenze.Notice.error({message: msg});

      if (loader)
        loader.stop();
    });

  };

  self.submitEnrollmentFields = function(vm, evt) {
    var loader = Ladda.create(evt.target);

    loader.start();

    if (self.program().current_user && self.program().current_user.for_credit_info) {
      var data = {
        user: {
          for_credit_info: ko.mapping.toJS(self.program().current_user.for_credit_info)
        }
      };

      data.user.for_credit_info = _.extend(
        data.user.for_credit_info,
        ko.mapping.toJS(self.enrollment_fields_info)
      );
    } else {
      var data = {user: {for_credit_info: ko.mapping.toJS(self.enrollment_fields_info)}};
    }

    var req = new Kadenze.AjaxRequest({
      type: 'PUT',
      url: Kadenze.Routes.users_path(),
      data: data
    });

    req.done(function(res) {
      self.enroll(vm, evt);
    });

    req.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.errors;
      }
      new Kadenze.Notice.error({message: msg});
    });

    req.always(function() {
      loader.stop();
    });
  };

  self.toggleSharePanel = function() {
    self.program().sharing(!self.program().sharing());
  };

  self.initSSOEvents = function() {
    $('#email-register-btn').click(function() {
      self.showSSORegister(false);
      self.showSSOLogin(false);
      self.showSignup(true);
    });

    $('#email-login-btn').click(function() {
      self.showSSORegister(false);
      self.showSSOLogin(false);
      self.showLogin(true);
    });

    $('.js-oauth-btn').click(function() {
      $.cookie('register.oauth', true, { expires: 1 });
    });
  };

  const __construct = function (that) {
    that.bindData(data);
    that.initSSOEvents();

    Kadenze.Share.init();
    Kadenze.UIUtil.initMultilineTruncation();

    InstructorCarousel.init();

    setTimeout(Kadenze.UIUtil.initLazyImageLoading, 300);
  }(this);
}
